import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import './index.css';

const { RangePicker } = DatePicker;

export const DatesPicker = (props) => {
  const {   updateConstraints } = props;
  const onChange = (dates, dateStrings) => {
    updateConstraints({
      startDate : dateStrings[0],
      endDate : dateStrings[1],
    });
  }
  return (
    <div className="range-picker">
      <RangePicker
        ranges={{
          Today: [moment(), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
        }}
        onChange={onChange}
      />
    </div>
  )
}
